import { mapGetters } from 'vuex';
import constants from '@/constants';

export default {
  computed: {
    ...mapGetters(['getFeatureSwitch']),

    isSamlEnabled() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.SAML_AUTH);
    },
  },
};
